<template>
  <div
    class="fixed bottom-0 left-0 right-0 bg-purple-700 text-white py-2.5 z-50 shadow-[0_0px_25px_0px_rgba(153,153,153,0.3)]"
  >
    <div
      class="container mx-auto flex flex-col md:flex-row justify-center items-center px-4"
    >
      <div class="flex items-center mb-2 md:mb-0">
        <span class="font-semibold mr-4"
          >HKTDC HONG KONG GIFTS & PREMIUM FAIR {{ year }} 🎁🚀</span
        >
      </div>
      <div>
        <!-- Countdown Timer -->
        <div class="flex space-x-0.5">
          <div class="text-center rounded bg-black w-[52px] py-1">
            <div class="text-dm font-bold px-2 rounded">
              {{ days }}
            </div>
            <div class="text-[11px]">Days</div>
          </div>
          <div class="text-center rounded bg-black w-[52px] py-1">
            <div class="text-dm font-bold px-2 rounded">
              {{ hours }}
            </div>
            <div class="text-[11px]">Hrs</div>
          </div>
          <div class="text-center rounded bg-black w-[52px] py-1">
            <div class="text-dm font-bold px-2 rounded">
              {{ minutes }}
            </div>
            <div class="text-[11px]">Min</div>
          </div>
          <div class="text-center rounded bg-black w-[52px] py-1">
            <div class="text-dm font-bold px-2 rounded">
              {{ seconds }}
            </div>
            <div class="text-[11px]">Sec</div>
          </div>
        </div>
      </div>

      <div class="mx-8">
        <div class="text-dm font-semibold">April 27 to 30, {{ year }}</div>
      </div>

      <div class="items-center bg-black px-2 py-2 rounded">
        <div class="text-sm font-semibold">🎁 Booth Number: 1B-F07</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      year: 2026,
      targetDate: new Date('April 27, 2027 00:00:00'),
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  },

  mounted() {
    // 计算年份
    this.updateYear()
    // Initialize countdown
    this.updateCountdown()
    // Update every second
    this.timer = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  },

  beforeDestroy() {
    // Clear interval when component is destroyed
    clearInterval(this.timer)
  },
  methods: {
    updateYear() {
      const date = new Date()
      const year = date.getFullYear() + 1
      this.year = year
      this.targetDate = new Date(`April 27, ${year} 00:00:00`)
    },
    updateCountdown() {
      const now = new Date()
      const difference = this.targetDate - now

      if (difference > 0) {
        this.days = Math.floor(difference / (1000 * 60 * 60 * 24))
        this.hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        )
        this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        this.seconds = Math.floor((difference % (1000 * 60)) / 1000)
      } else {
        // If event has passed, show zeros
        this.days = 0
        this.hours = 0
        this.minutes = 0
        this.seconds = 0
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/floatingBanner.vue